/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Office_Audit_DescriptionInputs */



/**
* | output |
* | --- |
* | "Review of shore-side management systems and procedures." |
*
* @param {Service_Office_Audit_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
export const service_office_audit_description = /** @type {((inputs?: Service_Office_Audit_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Office_Audit_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return /** @type {LocalizedString} */ ("审查岸基管理体系和程序。")
	return /** @type {LocalizedString} */ ("Review of shore-side management systems and procedures.")
});